/**
 * Hook to access user role information.
 * This is a convenience wrapper around useUserRoleContext for backward compatibility.
 * All role data is fetched once by UserRoleProvider and shared across all components.
 */

import { useUserRoleContext } from '../contexts/UserRoleContext'
import type { UserRoleResponse } from '../contexts/UserRoleContext'

// Re-export types for backward compatibility
export type { UserRoleResponse }

interface UseUserRoleReturn {
    role: string | null
    roleData: UserRoleResponse | null
    loading: boolean
    error: Error | null
    refetch: () => Promise<void>
}

/**
 * Hook to access user role information.
 * Returns the role ID (e.g., 'support', 'admin', 'platform_owner') and full role data.
 *
 * Note: This hook now uses UserRoleContext, which ensures only one API call is made
 * for role data, even when multiple components use this hook.
 */
export function useUserRole(): UseUserRoleReturn {
    return useUserRoleContext()
}
